import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

/**
 *  KAPCSOLATI KÓD – egy ügyfél adatforrása másik installációról (backend/kapcsolat.js).
 *
 *  Ha az iskola (adatgazda) nem ezen az installáción van, az adminja kapcsolati kódot generál
 *  (Admin → Kapcsolatok), és itt kell beírni. Ennyi a dolga a könyvelőnek; a kapcsolat azonnal él.
 *  Egy már meglévő kapcsolat (amit pl. a BÉR-ügyfélnél adtak meg) is kiválasztható.
 *
 *  `vegpont`: az ügyfél kapcsolat-végpontja (pl. `/api/ber-sulinform/kapcsolat/<id>` vagy
 *  `/api/naplo-kapcsolat/<id>`) – GET állapot, PUT { kod, url } | { kapcsolat_id } | { torol }.
 */
@Component({
  selector: 'app-kapcsolat-valaszto',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './kapcsolat-valaszto.component.html',
  styleUrls: ['./kapcsolat-valaszto.component.scss'],
})
export class KapcsolatValasztoComponent implements OnChanges {
  @Input() vegpont = '';
  /** Változott a kapcsolat (a szülő frissítheti a saját állapotát). */
  @Output() valtozott = new EventEmitter<any>();

  allapot: any = null;
  kod = '';
  url = '';
  kezi = false;              // kézzel megadott cím (ha nincs központi címjegyzék)
  fut = false;
  hiba = '';
  uzenet = '';

  constructor(private http: HttpClient) {}

  ngOnChanges() { if (this.vegpont) this.betolt(); }

  async betolt() {
    this.hiba = '';
    try { this.allapot = await firstValueFrom(this.http.get(this.vegpont)); }
    catch (e: any) { this.allapot = null; this.hiba = e?.error?.error || 'A kapcsolat állapota nem tölthető be.'; }
  }

  hatokorNev(h: string) { return this.allapot?.hatokorok?.[h]?.nev || h; }
  get valaszthato(): any[] { return (this.allapot?.valaszthato || []).filter((k: any) => k.id !== this.allapot?.aktualis?.id); }

  private async kuld(body: any, siker: string) {
    this.fut = true; this.hiba = ''; this.uzenet = '';
    try {
      const r: any = await firstValueFrom(this.http.put(this.vegpont, body));
      this.uzenet = r?.figyelmeztetes ? `${siker} ${r.figyelmeztetes}` : siker;
      this.kod = ''; this.url = '';
      await this.betolt();
      this.valtozott.emit(r?.kapcsolat || null);
    } catch (e: any) { this.hiba = e?.error?.error || 'A művelet nem sikerült.'; }
    this.fut = false;
  }
  csatlakozik() {
    if (!this.kod.trim()) { this.hiba = 'Írd be a kapcsolati kódot.'; return; }
    this.kuld({ kod: this.kod.trim(), url: this.kezi ? this.url.trim() : '' }, 'A kapcsolat létrejött.');
  }
  valaszt(id: string) { if (id) this.kuld({ kapcsolat_id: id }, 'A kapcsolat beállítva.'); }
  levalaszt() { this.kuld({ torol: true }, 'Leválasztva – az ügyfél adata ismét a helyi beállításból jön.'); }
}
